import React from 'react';
import PropTypes from 'prop-types';

const FeedbackCard = ({ children }) => {
  return (
    <div className="bg-gray-50 min-h-screen py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl mx-auto bg-white shadow-xl rounded-lg overflow-hidden">
        <div className="px-6 py-8 sm:px-10">
          {children}
        </div>
      </div>
    </div>
  );
};

FeedbackCard.propTypes = {
  children: PropTypes.node.isRequired,
};

export default FeedbackCard;